import { da } from 'react-date-range/dist/locale';
import { ENDPOINT_DATA_AXURE, ENDPOINT_DATA_GEOSERVICIOS } from '../constants';


/**
 * fetch from different url 
 * @param {string} url   endpoint
 * @param {object} data  {object with params}
 * @param {string} method GET,POST,....
 * @returns {JSON} the response of the request 
 */
const customFetch = async (url, data, method = 'GET') => {
    let response;
    try {
        if (method === 'GET') {
            response = await fetch(url);
        } else {
            response = await fetch(url, {
                method,
                headers: {
                    'Content-type': 'application/json',
                },
                body: JSON.stringify(data),
            });
        }
        const text = await response.text();
        return text ? JSON.parse(text) : {};
    } catch (error) {
        return null
    }
    
};

/**
 * Fetch services from GeoServicios
 * @param {object} data  {object with params}
 * @param {string} method GET,POST,....
 * @returns {GeoJSON} geoJson response of the request 
 */
const dataGeoServiciosFetch = async (data, method) => {
    return customFetch(ENDPOINT_DATA_GEOSERVICIOS, data, method);
};

/**
 * Fetch services from ApiAxureTechnologies
 * @param {object} data  {object with params}
 * @param {String} method GET,POST,....
 * @returns {JSON} the response of the request 
 */
const dataAxureFetch = async (data, method) => {
    return customFetch(ENDPOINT_DATA_AXURE, data, method);
};

const dataConsultaRayos = async (data, method) => {
    return customFetch(ENDPOINT_DATA_GEOSERVICIOS, data, method);
};


export { customFetch, dataAxureFetch, dataGeoServiciosFetch, dataConsultaRayos };
